import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

function Heading() {
  const navigate = useNavigate();

  return (
    <div className="my-8 flex items-center justify-between gap-4">
      <div className="text-lg font-bold sm:text-2xl">Simple assessment</div>
      <Button onClick={() => navigate("/free-assessment/questions")}>
        Continue
      </Button>
    </div>
  );
}

export default Heading;
